import { capitalize } from '../utils';
import { Address } from './address';
import { AddressPostal, AddressPostalAdapter } from './address-postal';
import { Certificate } from './certificate';
import { Education } from './education';
import { Experience } from './experience';
import { SocialInfo } from './socialinfo';

export interface Application {
  id: number;
  jobId: string;
  jobTitle: string;
  appliedAt?: any;
  formattedName: string;
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  mobile: string;
  email: string;
  experiences: Experience[];
  educations: Education[];
  totalExp: number;
  tenurePerEmployer: number;
  totalManagementExp: number;
  expDescription: string;
  currentManagementLevel: string;
  executiveType: string;
  managementStory: string;
  postalAddress?: AddressPostal;
  address?: Address;
  achievements: string[];
  certifications?: Certificate[];
  summary: string;
  qualifications: string;
  objective: string;
  socialInfo?: SocialInfo[];
}

export class ApplicationAdapter {
  constructor(public source?: Partial<Application>) {}

  get id() {
    return !!this.source && this.source.id;
  }

  get firstName() {
    return !!this.source && capitalize(this.source.firstName);
  }

  get lastName() {
    return !!this.source && capitalize(this.source.lastName);
  }

  private get address(): Address {
    return !!this.source && this.source.address;
  }

  private get postalAddress(): AddressPostalAdapter {
    return !!this.source && new AddressPostalAdapter(this.source.postalAddress);
  }

  get city(): string {
    return (
      (!!this.postalAddress && this.postalAddress.city) || (!!this.address && this.address.city)
    );
  }

  get country(): string {
    return (
      (!!this.postalAddress && this.postalAddress.country) ||
      (!!this.address && this.address.country)
    );
  }

  get state(): string {
    return (
      (!!this.postalAddress && this.postalAddress.state) || (!!this.address && this.address.state)
    );
  }

  get streetAddress(): string {
    return (
      (!!this.postalAddress && this.postalAddress.streetAddress) ||
      (!!this.address && this.address.streetAddress)
    );
  }

  get suiteNumber(): string {
    return !!this.address && this.address.suiteNumber;
  }

  get zipCode(): string {
    return (
      (!!this.postalAddress && this.postalAddress.zipCode) ||
      (!!this.address && this.address.zipCode)
    );
  }

  get email() {
    return !!this.source && this.source.email;
  }

  get experiences() {
    return !!this.source && this.source.experiences;
  }

  get mobile() {
    return !!this.source && this.source.mobile;
  }

  get tenurePerEmployer() {
    return !!this.source && this.source.tenurePerEmployer;
  }

  get totalExp() {
    return !!this.source && this.source.totalExp;
  }

  get achievements() {
    return !!this.source && this.source.achievements;
  }

  get certifications() {
    return !!this.source && this.source.certifications;
  }

  get summary() {
    return !!this.source && this.source.summary;
  }

  get qualifications() {
    return !!this.source && this.source.qualifications;
  }

  get objective() {
    return !!this.source && this.source.objective;
  }

  get appliedAt() {
    return !!this.source && this.source.appliedAt;
  }
}
